import { createApi } from '@reduxjs/toolkit/query/react'

import { baseQuery } from '@/core/api/baseQuery'

export const preferenciaMonedaApi = createApi({
  reducerPath: 'preferenciaMonedaApi',
  baseQuery,
  endpoints: (builder) => ({
    getPreferenciaMoneda: builder.query<number | null, void>({
      query: () => ({
        url: `/PreferenciaMonedaBusiness`,
        method: 'GET',
      }),
    }),
    putPreferenciaMoneda: builder.mutation<void, number>({
      query: (preferenciaMonedaId) => ({
        url: `/PreferenciaMonedaBusiness(${preferenciaMonedaId})`,
        method: 'PUT',
      }),
    }),
  }),
})

export const { useLazyGetPreferenciaMonedaQuery, usePutPreferenciaMonedaMutation } = preferenciaMonedaApi
